import React from 'react';
import numeral from 'numeral';
import BiddingItemSC from './bidding-item.styled';
import { BodyText } from '../../../typography';
import Mark from '../../../ui/mark';
import Button from '../../../ui/button';
import { formatDayCount, getColorByStatus } from '../../../../utils/helpers';
import dlt from '../../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ClockIcon } from '../../../../assets/img/svg/small-clock.svg';
import { ReactComponent as CheckIcon } from '../../../../assets/img/svg/small-check.svg';
import { ReactComponent as CrossIcon } from '../../../../assets/img/svg/small-cross.svg';

const BiddingItem = ({
  isTablet,
  onSellClick,
  onBidClick,
  onCancelClick,
  buyerWmNumber,
  amountForSale,
  buyerLastBid,
  sellerLastBid,
  showButtons,
  status,
  timeRemaining,
  lastBidder,
}) => {
  return (
    <BiddingItemSC>
      {isTablet ? (
        <>
          <td>
            <BodyText className="bolder">ID {buyerWmNumber}</BodyText>
            <BodyText>{numeral(amountForSale).format('0,00.00')} €</BodyText>
          </td>
          <td>
            <BodyText
              className={
                sellerLastBid && lastBidder === 's'
                  ? 'bolder green'
                  : sellerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lightest'
              }
            >
              {sellerLastBid ? numeral(sellerLastBid).format('0,00.00') : '--'} €
            </BodyText>
            <BodyText
              className={
                buyerLastBid && lastBidder === 'b'
                  ? 'bolder green'
                  : buyerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lighter'
              }
            >
              {buyerLastBid ? numeral(buyerLastBid).format('0,00.00') : '--'} €
            </BodyText>
          </td>
        </>
      ) : (
        <>
          <td>
            <BodyText className="bolder">ID {buyerWmNumber}</BodyText>
          </td>
          <td>
            <BodyText>{numeral(amountForSale).format('0,00.00')} €</BodyText>
          </td>
          <td>
            <BodyText
              className={
                buyerLastBid && lastBidder === 'b'
                  ? 'bolder green'
                  : buyerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lighter'
              }
            >
              {buyerLastBid ? numeral(buyerLastBid).format('0,00.00') : '--'} €
            </BodyText>
          </td>
          <td>
            <BodyText
              className={
                sellerLastBid && lastBidder === 's'
                  ? 'bolder green'
                  : sellerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lightest'
              }
            >
              {sellerLastBid ? numeral(sellerLastBid).format('0,00.00') : '--'} €
            </BodyText>
          </td>
        </>
      )}
      <td>
        {!showButtons ? (
          <>
            {timeRemaining ? (
              <Mark>
                <span className="table-cell-status bold">
                  <ClockIcon />
                  <FormattedMessage
                    id="investor_bidding_table_item_awaits_response"
                    defaultMessage={dlt['investor_bidding_table_item_awaits_response']}
                  />
                  <b>
                    (<FormattedMessage id="global_remains" defaultMessage={dlt['global_remains']} />{' '}
                    {timeRemaining}{' '}
                    <FormattedMessage
                      id={formatDayCount(timeRemaining)}
                      defaultMessage={dlt[`${formatDayCount(timeRemaining)}`]}
                    />
                    )
                  </b>
                </span>
              </Mark>
            ) : !timeRemaining && status ? (
              <Mark colorStyle={getColorByStatus(status)}>
                <span className="table-cell-status bold">
                  {getColorByStatus(status) === 'GREEN' ? (
                    <CheckIcon />
                  ) : getColorByStatus(status) === 'RED' ? (
                    <CrossIcon />
                  ) : getColorByStatus(status) === 'ORANGE' ? (
                    <ClockIcon />
                  ) : null}
                  <FormattedMessage
                    id={`investor_bidding_status_${status}`}
                    defaultMessage={dlt[`investor_bidding_status_${status}`]}
                  />
                </span>
              </Mark>
            ) : null}
          </>
        ) : (
          <>
            <Button
              type="PRIMARY"
              className="sell-button"
              size="MEDIUM"
              onClick={(event) => onSellClick(event)}
            >
              <FormattedMessage id="global_sell" defaultMessage={dlt['global_sell']} />
            </Button>
            <Button
              type="OUTLINED"
              className="bid-button"
              size="MEDIUM"
              onClick={(event) => onBidClick(event)}
            >
              <FormattedMessage id="global_bid" defaultMessage={dlt['global_bid']} />
            </Button>
            <Button
              type="OUTLINED"
              className="cancel-button"
              size="MEDIUM"
              onClick={(event) => onCancelClick(event)}
            >
              <FormattedMessage id="global_refuse" defaultMessage={dlt['global_refuse']} />
            </Button>
          </>
        )}
      </td>
    </BiddingItemSC>
  );
};

export default BiddingItem;
